export const AppPermissions = {
    // Main permissions
    PortalAccess: ["BOSOS.PortalAccess@BOSOS"],
}